import { useEffect } from "react";

export default function useFocus(ref) {
    useEffect(() => {
        setTimeout(() => ref.current?.focus?.());
    }, [ref?.current])
}